import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FooterLink } from 'src/app/interfaces/footer-link';
import { SkeletonServiceService } from '../../skeleton-service.service';
import { FOOTER_ABOUT_MENUS, FOOTER_AIDE_MENUS, FOOTER_INFO_MENUS, FOOTER_PARTNERS } from 'src/app/constants/footer-menu.constant';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Output() moveTop = new EventEmitter<boolean>(false);
  partners: Array<{name: string, link?: string}> = FOOTER_PARTNERS;
  aboutMenus: Array<FooterLink> = FOOTER_ABOUT_MENUS;
  infoMenus: Array<FooterLink> = FOOTER_INFO_MENUS;
  aideMenus: Array<FooterLink> = FOOTER_AIDE_MENUS;

  constructor(private router: Router, private skeletonService: SkeletonServiceService) { }
  get socialMediaLinks() {
    return this.skeletonService.theme.socialMedia
  }

  get isMobile(){
    return this.skeletonService.isMobile();
  }

  get currentYear(){
    return (new Date().getFullYear());
  }
  openMiscInfo(activeTab) {
    let subPath = activeTab.id ? activeTab.id : null;
    if(activeTab.id === 'play-responsibly') {
      window.open(activeTab.link, '_blank');
      return;
    }

    if(subPath){
      this.moveTop.emit(true);
      this.router.navigate([activeTab.link, subPath]);
    }else {
      this.moveTop.emit(true);
      this.router.navigate([activeTab.link]);
    }
  }
}
